import { Grid } from '~/engine/data/common/Grid';
import {
    ResampleVolumeOptions,
    VolumeMapping,
    resampleVolumeInto,
} from '~/domain/services/resampleVolume';

export interface DoseOutsideGrid {
    // Voxels of the dose above 0 Gy.
    readonly plannedVoxels: number;
    // Of those, voxels whose centers fall outside the grid: their dose is lost on it.
    readonly outsideVoxels: number;
    // Highest dose (Gy) among the voxels outside, 0 when none are.
    readonly maxOutsideGy: number;
}

// How much of a planned dose lies outside a grid it is resampled onto; the mapping takes dose points to grid points.
export async function doseOutsideGrid(
    doseGy: Float32Array,
    doseGrid: Grid,
    grid: Grid,
    doseToGrid: VolumeMapping,
    options: Omit<ResampleVolumeOptions, 'backgroundValue'> = {}
): Promise<DoseOutsideGrid | null> {
    const inside = new Int16Array(doseGy.length);
    const coverage = await resampleVolumeInto(
        new Int16Array(grid.sizeX * grid.sizeY * grid.sizeZ).fill(1),
        grid,
        inside,
        doseGrid,
        doseToGrid,
        { ...options, backgroundValue: 0 }
    );
    if (!coverage) {
        return null;
    }
    let plannedVoxels = 0;
    let outsideVoxels = 0;
    let maxOutsideGy = 0;
    for (let i = 0; i < doseGy.length; i++) {
        if (doseGy[i] > 0) {
            plannedVoxels++;
            if (inside[i] === 0) {
                outsideVoxels++;
                maxOutsideGy = Math.max(maxOutsideGy, doseGy[i]);
            }
        }
    }
    return { plannedVoxels, outsideVoxels, maxOutsideGy };
}
